import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=295a630b"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/myapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('295a630b')) {
      api.createRecord('295a630b', component.options)
    } else {
      api.reload('295a630b', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=295a630b", function () {
      api.rerender('295a630b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/Header.vue"
export default component.exports